module.exports = __webpack_public_path__ + "static/media/webhook.e5374d73.png";